namespace TabAurous.Scheme {
    export interface SchemePaymentDetailsRow {
        SchemeDetailsId?: number;
        SchemePaymentId?: number;
        LedgerId?: number;
        ModeId?: number;
        Code?: string;
        Amount?: number;
        RefNo?: string;
        ChequeNo?: number;
        ChequeDate?: string;
    }

    export namespace SchemePaymentDetailsRow {
        export const idProperty = 'SchemeDetailsId';
        export const localTextPrefix = 'Scheme.SchemePaymentDetails';
        export const deletePermission = 'Scheme:Payment:Delete';
        export const insertPermission = 'Scheme:Payment:Add';
        export const readPermission = '*';
        export const updatePermission = 'Scheme:Payment:Edit';

        export declare const enum Fields {
            SchemeDetailsId = "SchemeDetailsId",
            SchemePaymentId = "SchemePaymentId",
            LedgerId = "LedgerId",
            ModeId = "ModeId",
            Code = "Code",
            Amount = "Amount",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate"
        }
    }
}
